// extracted by css-extract-rspack-plugin
export default {"benefitList":"benefit-list--vU7TzK1Z447hfrKj","benefitListItem":"benefit-list-item--d8P5pdGmxsSBBUvL","benefitCollapsed":"benefit-collapsed--jBKsXX5XocAS5IKb"};